/**
 * Inline user picker for sharing a filter preset.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Checkbox } from '@/components/ui';
import { useShareableUsers } from '@/features/smswiser-campaigns/hooks/useSavedFilters';

interface UserSharePickerProps {
  selected: Set<string>;
  onToggle: (userId: string) => void;
}

export const UserSharePicker: FC<UserSharePickerProps> = ({ selected, onToggle }) => {
  const { data: users = [], isLoading } = useShareableUsers();

  if (isLoading) {
    return <p className="text-xs text-muted-foreground">Loading users…</p>;
  }
  if (users.length === 0) {
    return <p className="text-xs text-muted-foreground">No other users.</p>;
  }

  return (
    <div className="max-h-[120px] space-y-px overflow-y-auto rounded-md border border-border/50 p-1">
      {users.map((u) => (
        <label key={u.id} className="flex cursor-pointer items-center gap-1.5 rounded px-1.5 py-1 text-xs hover:bg-muted/40">
          <Checkbox checked={selected.has(u.id)} onCheckedChange={() => onToggle(u.id)} className="h-3.5 w-3.5" />
          <span className="truncate">
            {u.firstName} {u.lastName}
            <span className="ml-1 text-[10px] text-muted-foreground">{u.email}</span>
          </span>
        </label>
      ))}
    </div>
  );
};
